import React from 'react';
import useIsMobileLayout from '../../hooks/useIsMobileLayout';

/**
 * StickyPageTopbar — ページ上部固定ヘッダーの共通実装（Web）。
 *
 * 券売分析の `.taa-topbar` を汎用化したもの。上部固定（position:sticky top:0）・
 * 角丸なし・余白なしのフラットなバーで、スクロールしても上部に張り付く。
 *
 * - 左: ページタイトル（SP=アプリ/共通ヘッダーが出すため非表示）＋任意の左スロット
 *   （`children`にイベント切替 `DsSelect` やサブタイトル等を差す）。
 * - 右: `actions` スロット（主要アクション）。
 * - 「戻る」はヘッダーに置かず、本文最下部へ `.page-back-row` で配置する運用。
 * - 本文は `<div className="page-topbar-body">` で内側余白を持たせ、ページ側コンテナの
 *   padding は 0 にする（バーをフラッシュにするため）。
 *
 * SPでは `useIsMobileLayout()` によりタイトルを畳み、バーを単一行に圧縮して高さを節約する。
 */
export default function StickyPageTopbar({ title, children, actions, className = '' }) {
  const isMobileTitleLayout = useIsMobileLayout();
  return (
    <header className={['page-topbar', className].filter(Boolean).join(' ')}>
      <div className="page-topbar__left">
        {!isMobileTitleLayout && title ? (
          <h2 className="page-topbar__title">{title}</h2>
        ) : null}
        {children}
      </div>
      {actions ? <div className="page-topbar__actions">{actions}</div> : null}
    </header>
  );
}
